import dayjs from 'dayjs'

export default function fromTime(date: Date) {
  const diffInSeconds = dayjs().diff(date, 's')
  const diffInMinutes = dayjs().diff(date, 'm')
  const diffInHours = dayjs().diff(date, 'h')
  const diffInDays = dayjs().diff(date, 'd')
  const diffInMonths = Math.round(dayjs().diff(date, 'M', true))
  const diffInYears = Math.trunc(dayjs().diff(date, 'y', true))

  if (diffInSeconds < 60) {
    return '1 min'
  } else if (diffInMinutes <= 60) {
    return `${diffInMinutes} min(s)`
  } else if (diffInHours <= 24) {
    return `${diffInHours} hr(s)`
  } else if (diffInDays <= 30) {
    return `${diffInDays} día(s)`
  } else if (diffInMonths <= 12) {
    return `${diffInMonths} mes(es)`
  } else if (diffInYears <= 1) {
    return `${diffInYears} año`
  } else {
    return `${diffInYears} años`
  }
}
